// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ik-0";
export var assigneeDetails = "_ik-1";
export var assigneeInfo = "_ik-2";
export var dropdownContainer = "_ik-4";
export var dropdownImage = "_ik-5";
export var editAssigneeInfo = "_ik-3";
export var editAssigneeModalContainer = "_ik-6";
export var hidden = "_ik-8";
export var input = "_ik-7";